module.exports = __webpack_public_path__ + "img/Feedback-rafiki.baabf3e9.svg";